import { Text } from '@thefarmersfront/kitchen';

import { CircleProgress } from '~/components/common/chart/CircleProgress';

import { formatNumber } from '~/utils/common';

import { SummaryItem } from '../SummaryItem';

import styles from './DeliveryAgencyDeliveryStatusTotalShippingLabels.module.scss';

interface DeliveryAgencyDeliveryStatusTotalShippingLabelsProps {
  totalCount: number;
  dawnDeliveryCount: number;
  dayDeliveryCount: number;
}

const DeliveryAgencyDeliveryStatusTotalShippingLabels = ({
  totalCount,
  dawnDeliveryCount,
  dayDeliveryCount,
}: DeliveryAgencyDeliveryStatusTotalShippingLabelsProps) => {
  const dawnPercent = totalCount > 0 ? Math.round((dawnDeliveryCount / totalCount) * 100) : 0;

  return (
    <div className={styles.container}>
      <SummaryItem title="배송 요청">
        <CircleProgress
          percent={dawnPercent}
          value={formatNumber(totalCount)}
          suffix="건"
          trackColor={totalCount > 0 ? '#5094DC' : '#E8E8E8'}
          progressColor="#BD76FF"
          hasRoundCap={false}
          labelFontStyle={{ fontSize: 24, fontWeight: 700 }}
          suffixFontStyle={{ fontSize: 24, fontWeight: 700, dx: 0, dy: 0 }}
        />
        <div className={styles['label-group']}>
          <div className={styles.label}>
            <div className={styles['label-dot--dawn']} />
            <Text size="large" weight="regular">
              샛별배송: {formatNumber(dawnDeliveryCount)}
            </Text>
          </div>
          <div className={styles.label}>
            <div className={styles['label-dot--day']} />
            <Text size="large" weight="regular">
              하루배송(택배): {formatNumber(dayDeliveryCount)}
            </Text>
          </div>
        </div>
      </SummaryItem>
    </div>
  );
};

export { DeliveryAgencyDeliveryStatusTotalShippingLabels };
